import * as React from "react";
import type { SVGProps } from "react";
const SvgCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    fillRule="evenodd"
    clipRule="evenodd"
    imageRendering="optimizeQuality"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 4233.32 4233.32"
    {...props}
  >
    <path
      fillRule="nonzero"
      d="M2116.54-.01c582.44 0 1111.85 238.25 1495.22 621.62 383.37 383.37 621.63 912.78 621.63 1494.98 0 582.32-238.26 1111.74-621.63 1495.11-383.37 383.36-912.78 621.62-1494.98 621.62-582.44 0-1111.85-238.26-1495.22-621.62C238.19 3228.33-.07 2698.91-.07 2116.71c0-582.32 238.26-1111.73 621.63-1495.1C1004.93 238.24 1534.34-.01 2116.54-.01zm.24 295.34c-500.93 0-956.27 205-1286.39 535.11-330.11 330.12-535.11 785.46-535.11 1286.15 0 500.81 205 956.16 535.11 1286.27 330.12 330.11 785.46 535.11 1286.15 535.11 500.93 0 956.27-205 1286.39-535.11 330.11-330.11 535.11-785.46 535.11-1286.15 0-500.81-205-956.15-535.11-1286.27-330.12-330.11-785.46-535.11-1286.15-535.11z"
      className="fil0"
    />
  </svg>
);
export default SvgCircle;
